import React from 'react';
import PropTypes from 'prop-types';
import styles from './Hamburger.module.css';

const Hamburger = ({ toggle, toggled }) => {
  return (
    <div className="hamburger-menu" onClick={toggle}>
      <div className={styles.hamburgerLines}>
        <span className={`${styles.line} ${toggled ? styles.line1Active : ''}`}></span>
        <span className={`${styles.line} ${toggled ? styles.line2Active : ''}`}></span>
        <span className={`${styles.line} ${toggled ? styles.line3Active : ''}`}></span>
      </div>
    </div>
  );
};

Hamburger.propTypes = {
  toggle: PropTypes.func.isRequired,
  toggled: PropTypes.bool.isRequired,
};

export default Hamburger; 


// WEBPACK FOOTER //
// ./src/components/Hamburger.js